import { render, staticRenderFns } from "./ac-newsection.vue?vue&type=template&id=21a4cabd&"
import script from "./ac-newsection.vue?vue&type=script&lang=js&"
export * from "./ac-newsection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports